import React from "react"
import types from "prop-types"
import { dynamicRangeTasksExample, monthRangeTaskInclusionDescription } from "utils/scheduledReportExportHelpers"

const MonthsTaskDateDescription = ({ dateFilterType, startDate, taskPreviousRangeLength = null }) => {
  const monthCount = taskPreviousRangeLength || 1

  const beginningDate = startDate.subtract(monthCount, "M").startOf("month")
  const endingDate = startDate.subtract(1, "M").endOf("month")

  return (
    <div className="text-xs text-dark mt-2">
      <p className="mb-4">
        {monthRangeTaskInclusionDescription(dateFilterType)}
      </p>
      <p>
        {dynamicRangeTasksExample({
          startDate, beginningDate, endingDate, dateFilterType,
        })}
      </p>
    </div>
  )
}

MonthsTaskDateDescription.propTypes = {
  dateFilterType: types.string.isRequired,
  startDate: types.object.isRequired,
  taskPreviousRangeLength: types.number,
}

export default MonthsTaskDateDescription
